<script>
export default {
  name: "TheInformationCompetitionDialog",

  props: {
    visible: Boolean,
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="show"
    width="600px"
    content-class="rounded-xl"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        <span class="text-h5">Информация по подаче заявления ПГАС</span>
      </v-card-title>

      <v-card-text>
        <span class="text-h6">1</span> Для успешной подачи заявки на повышенную стипендию необходимо выбрать соответствующие достижения из
        представленной таблицы. Обратите внимание на различные категории достижений и выберите те,
        которые наилучшим образом отражают ваши успехи.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">2</span> Используя выпадающий список, укажите тип деятельности,
        к которой относятся выбранные вами достижения.
        Это важный шаг для правильной классификации вашей заявки.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">3</span>
        Перед тем как отправить вашу заявку на повышенную стипендию, необходимо удостовериться, что вы внимательно ознакомились с положением.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">4</span>
        Будьте внимательны при заполнении информации о достижениях, так как они будут подвергнуты дополнительной модерации.
        В случае выявления недостоверных данных или нарушения правил, ваша достижение из заявки может быть удалена.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">5</span>
        Пожалуйста, помните, что достижения, которые уже были использованы или прошли ранее,
        не учитываются при оценке рейтинга для повышенной стипендии.
        Убедитесь, что выбираете новые и актуальные достижения.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">6</span>
        Учтите, что достижения, которые ранее способствовали вашему успешному прохождению конкурса и кандидатуре на получение ПГАС,
        не учитываются при формировании нового заявления. Пожалуйста, убедитесь, что выбраны актуальные достижения
      </v-card-text>

      <v-card-text>
        <span class="text-h6">7</span>
        Для завершения процесса подачи заявки нажмите на соответствующую кнопку "Сохранить".
        Это действие подтвердит ваш выбор достижений и завершит процедуру подачи заявки.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="teal darken-3"
          class="rounded-xl white--text"
          @click="show = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>